import { render, staticRenderFns } from "./UserDetailsAdmin.vue?vue&type=template&id=44be4ba3&"
import script from "./UserDetailsAdmin.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports